'use client';
import React, { useEffect, useState } from 'react';

export default function StickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 1.6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 sticky-bar transition-all duration-500 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <p className="hidden md:block text-sm text-white/50 font-body">
          <span className="text-mint font-medium">47,382 luck incidents</span> logged today — add yours to the map.
        </p>
        <div className="flex items-center gap-4 w-full md:w-auto justify-center md:justify-end">
          <a href="#" className="text-sm text-white/40 hover:text-white/70 transition-colors font-body underline underline-offset-4 hidden sm:block">
            Browse the live feed
          </a>
          <a
            href="#"
            className="cta-primary mint-glow inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-display font-700"
          >
            Log Your Luck
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}